import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=48796d4e&scoped=true&"
import script from "./crm.vue?vue&type=script&lang=js&"
export * from "./crm.vue?vue&type=script&lang=js&"
import style0 from "./crm.vue?vue&type=style&index=0&id=48796d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48796d4e",
  null
  
)

export default component.exports